import React, { useState, useEffect } from "react";
import Button from "../components/Button";
import Header from "../components/Header";
import ManageAvatar from "../components/ManageAvatar";
import { useStateContext } from "../contexts/ContextProvider";

import { MdVerifiedUser } from "react-icons/md";
import { FaChevronRight } from "react-icons/fa6";
import ChangeEmailModal from "../components/ChangeEmailModal";
import { AlertBox, VerifyIdModal } from "../components";
import { useNavigate } from "react-router-dom";
import { apiUpdateUser } from "../services/apiService";

const Profile = () => {
  const { user, setUser, alert, handleAlert, modal, handleModal } =
    useStateContext();
  const [newUser, setNewUser] = useState(user);
  const [isSaveRequired, setIsSaveRequired] = useState(false);
  const [isDisabled, setIsDisabled] = useState(
    user.idStatus === "verified" ? true : false
  );

  const navigate = useNavigate();

  useEffect(() => {
    setNewUser(user);
  }, [user]);

  useEffect(() => {
    if (
      newUser.firstName !== user.firstName ||
      newUser.middleName !== user.middleName ||
      newUser.lastName !== user.lastName ||
      newUser.defaultView !== user.defaultView ||
      newUser.publicAlias !== user.publicAlias ||
      newUser.bio !== user.bio
    ) {
      setIsSaveRequired(true);
    } else {
      setIsSaveRequired(false);
    }
  }, [user, newUser]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewUser((prevState) => ({ ...prevState, [name]: value }));
  };

  const saveNewUser = async () => {
    const response = await apiUpdateUser(user.id, newUser);
    if (response.hasError) {
      console.log(response.error.response.statusText);
      return;
    } else {
      setUser(response.data);
    }
  };

  return (
    <>
      <section id="header" className="">
        <Header />
      </section>
      <section
        id="profile"
        className="fixed left-0 right-0 top-20 bottom-0 overflow-auto overscroll-none"
      >
        {alert.newProfile && (
          <AlertBox alertType="newProfile" handleAlert={handleAlert} />
        )}
        {modal.verifyId && <VerifyIdModal />}
        {modal.changeEmail && <ChangeEmailModal oldEmail={user.email} />}
        <div className="mt-3 mb-5">
          <ManageAvatar />
        </div>
        <div className="flex flex-wrap justify-center mt-5 gap-x-2 gap-y-2">
          <div
            className="flex justify-center items-center text-sm text-white bg-blue-500 
          rounded-3xl p-1.5"
          >
            <MdVerifiedUser className="text-lg mr-1" />
            Email Verified
          </div>
          <div
            className={`flex justify-center items-center text-sm rounded-3xl py-1.5 px-2 
            ${
              user.idStatus === "verified"
                ? "text-white bg-blue-500 cursor-default"
                : user.idStatus === "pending"
                ? "text-white bg-yellow-500 cursor-default"
                : "text-gray-500 bg-gray-300 hover:text-white hover:bg-blue-500 cursor-pointer"
            }`}
            onClick={
              user.idStatus === "verified" || user.idStatus === "pending"
                ? () => {}
                : () => handleModal("verifyId")
            }
          >
            <MdVerifiedUser className="text-lg mr-1" />
            {user.idStatus === "verified"
              ? "ID Verified"
              : user.idStatus === "pending"
              ? "ID Pending"
              : "Get ID Verfied"}
          </div>
          {/* <div
            className="flex justify-center items-center text-sm text-gray-500 bg-gray-300 
          rounded-3xl p-1.5"
          >
            <MdVerifiedUser className="text-lg mr-1" />
            Get Phone Verified
          </div> */}
        </div>
        <div className="flex justify-center">
          <form className="grid mt-5 gap-y-2 ">
            <label className="grid grid-cols-3 text-blue-500 text-base relative">
              Public Alias:
              <input
                id="public-alias"
                name="publicAlias"
                type="text"
                value={newUser.publicAlias}
                onChange={handleChange}
                className="absolute left-24 col-span-2 text-black border-gray-300 border-b-1
                 outline-snappily-orange pl-1"
              />
            </label>
            <label className="grid grid-cols-3 relative">
              First Name:
              <input
                id="first-name"
                name="firstName"
                type="text"
                disabled={isDisabled}
                value={newUser.firstName}
                autoComplete="given-name"
                onChange={handleChange}
                className={`absolute text-black left-24 col-span-2 border-gray-300 border-b-1
                 outline-snappily-orange pl-1 ${
                   isDisabled ? "text-gray-400 italic" : ""
                 }`}
              />
            </label>
            <label className="grid grid-cols-3 relative">
              Middle:
              <input
                id="middle-name"
                name="middleName"
                type="text"
                disabled={isDisabled}
                value={newUser.middleName || ""}
                autoComplete="additional-name"
                onChange={handleChange}
                className={`absolute text-black left-24 col-span-2 border-gray-300 border-b-1
                 outline-snappily-orange pl-1 ${
                   isDisabled ? "text-gray-400 italic" : ""
                 }`}
              />
            </label>
            <label className="grid grid-cols-3 relative">
              Last Name:
              <input
                id="last-name"
                name="lastName"
                type="text"
                disabled={isDisabled}
                value={newUser.lastName}
                autoComplete="family-name"
                onChange={handleChange}
                className={`absolute text-black left-24 col-span-2 border-gray-300 border-b-1
                 outline-snappily-orange pl-1 ${
                   isDisabled ? "text-gray-400 italic" : ""
                 }`}
              />
            </label>
            <div className="grid grid-cols-3 relative">
              Email:
              <div
                className="flex items-center absolute left-24 col-span-2"
                onClick={() => {
                  if (isSaveRequired) saveNewUser();
                  handleModal("changeEmail");
                }}
              >
                <div
                  className="w-[182px] border-gray-300 border-b-1 bg-white
                  truncate text-ellipsis pl-1"
                >
                  {user.email.toLowerCase()}
                </div>
                <FaChevronRight className=" text-gray-400" />
              </div>
            </div>
            <label className="grid">
              Bio:
              <textarea
                id="bio"
                name="bio"
                type=""
                maxLength={1000}
                placeholder="Tell the world about this yourself."
                value={newUser.bio || ""}
                className={`justify-items-left h-60 w-72 border-gray-300 border-1 rounded-lg p-2 `}
                onChange={handleChange}
              />
            </label>
          </form>
        </div>
        <div className="flex justify-center w-full mt-5 mb-20">
          <Button
            background="bg-slate-400"
            text="text-white"
            opacity="bg-opacity-100"
            title={isSaveRequired ? "Cancel" : "Close"}
            height="h-10"
            width="w-24"
            borderColor="border-none"
            borderHover="hover:border-snappily-orange"
            customFunc={() => {
              navigate("/dashboard");
            }}
          />
          {isSaveRequired && (
            <Button
              background="bg-snappily-orange"
              text="text-white"
              opacity="bg-opacity-100"
              title="Save"
              height="h-10"
              width="w-24"
              borderColor="border-none"
              borderHover="hover:border-snappily-orange"
              customFunc={saveNewUser}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default Profile;
